import Nationalities from "../constants/nationalities";

export const getNationality = (id) => {
  const nationality = Nationalities.find(
    (nationality) => nationality.id === id
  );
  return nationality.description;
};
